import { Tenant } from './tenant';

export interface TenantProvider {
    applicationId: string;
    applicationSecret?: string;
    azureConfigured?: boolean;
    connectionDetails?: ConnectionDetailsType;
    enabled: boolean;
    googleConfigured?: boolean;
    id: string;
    identityTenantId: string;
    providerType: ProviderType;
    platformTenantId: string;
    tenant?: Tenant;
    useAsmAppCredentials: boolean | null;
}

export enum ProviderType {
    Microsoft = 'Microsoft',
    Google = 'Google'
}

export interface AugmentedTenant extends Tenant {
    providerType: ProviderType | null;
}

export interface ConnectionDetailsType {
    azureEnabled?: boolean;
    googleEnabled?: boolean;
    isUpdateRequired?: boolean;
    id?: string;
    [k: string]: unknown;
}
